const UserRole = {
	USER: "USER",
	ADMIN: "ADMIN"
}

export default UserRole;